import React from "react";
import { View, ViewDensity } from "@common/types/views/views";
import { useEntities } from "@hooks/useEntities";
import { HELP_CENTER_URLS, useHelpCenterUrl } from "@hooks/useHelpCenterUrl";
import { ArrowCornerIcon } from "@icons";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import styles from "./WorkspaceLock.module.scss";
import {
    WorkspaceLockColumn,
    workspaceLockViewConfig,
} from "./workspaceLockViewConfig";

const defaultView: View = {
    columns: [
        { id: WorkspaceLockColumn.STATUS },
        { id: WorkspaceLockColumn.ENTITY },
        { id: WorkspaceLockColumn.LOCK_DATE },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
        density: ViewDensity.SM,
    },
};

export const WorkspaceLock: React.FC = () => {
    const entities = useEntities({
        onlyBusiness: true,
    });
    const locksHelpCenterUrl = useHelpCenterUrl(HELP_CENTER_URLS.locks);

    return (
        <section>
            <header className="settings__header">
                <h3>Locks</h3>
            </header>

            <p className={styles.lockDescription}>
                Locks allow Workspace Admins and Accountants to prevent account
                changes during specific time periods.
                {locksHelpCenterUrl && (
                    <>
                        <br />
                        <a
                            href={locksHelpCenterUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.moreLink}
                        >
                            More about locks <ArrowCornerIcon />
                        </a>
                    </>
                )}
            </p>

            <main>
                <ViewTable
                    data={entities}
                    view={defaultView}
                    config={workspaceLockViewConfig}
                    emptyView={() => (
                        <EmptyState header="No business entities available for locking." />
                    )}
                    enableColumnResizing={false}
                    outerBorder
                />
            </main>
        </section>
    );
};
